import React from "react"
import { Link } from "gatsby"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "./Button"
import BackgroundVideo from "./BackgroundVideo"
import wavy from "../../assets/svg/wavy.svg"

const useStyles = makeStyles(theme => ({
  Section: {
    position: "relative",
    background: theme.palette.background.paper,
    padding: theme.spacing(10, 2),
    "&:before": {
      position: "absolute",
      top: -70,
      left: 0,
      right: 0,
      width: "inherit",
      height: theme.spacing(10),
      content: `''`,
      background: `url(${wavy}) no-repeat`,
      backgroundSize: "100%",
    },
  },
  cateringMenu: {
    margin: "auto",
    padding: theme.spacing(2, 2),
    textAlign: "center",
    maxWidth: 1200,
  },
  quote: {
    fontFamily: "RageItalic",
    fontSize: theme.typography.fontSize + 32,
    fontWeight: 900,

    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.fontSize + 12,
    },
  },

  caption1: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(2, 1),
    background: theme.palette.background.paper,
    position: "relative",
    overflow: "hidden",
  },
  vidCustomStyle: {
    height: "120%",
    top: -25,
  },
  container: {
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
    margin: "auto",
    padding: theme.spacing(2),
    border: "1px solid",
    borderColor: theme.palette.secondary.main,
    borderRadius: "8px",
    textAlign: "center",
    "& hr": {
      display: "inline-block",
      width: "10%",
      margin: theme.spacing(1),
      border: ".5px thin",
      borderColor: theme.palette.secondary.main,
    },
    "& p:last-of-type": {
      maxWidth: 600,
      fontStyle: "italic",
      margin: "auto",
    },
  },
}))
const vidurl = Object.freeze({
  title: "gloone_kitchen_cooking_soup_banga",
  videoSrcUrl: "/gloone_kitchen_cooking_soup_banga.mp4",
})
export const CateringMenu = () => {
  const classes = useStyles()
  return (
    <Box component="section" className={classes.Section}>
      <Box className={classes.cateringMenu}>
        <Typography component="blockquote" className={classes.quote}>
          "The feature of Catering services start from here"
        </Typography>
        <Box p={0} mt={3}>
          <Button component={Link} to="/kitchen/#event-catering-menu">
            CHECKOUT OUR CATERING MENU
          </Button>
          <Button component={Link} to="#contact-form" secondary>
            GET STARTED
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export const Caption1 = () => {
  const classes = useStyles()

  return (
    <Box component="section" className={classes.caption1}>
      <BackgroundVideo
        title={vidurl.title}
        _mp4_src={vidurl.videoSrcUrl}
        vidCustomStyle={classes.vidCustomStyle}
      />
      <Box className={classes.container}>
        <hr />
        <Typography component="blockquote" className={classes.quote}>
          Something for everyone!
        </Typography>{" "}
        <hr />
        <Typography paragraph>
          "Whether you are in need of a full catering service for that special
          event you've got coming up or just at the comfort of your home, office
          in need of a quick meal fix.. Take advantage of our food delivery
          service."
        </Typography>
      </Box>
    </Box>
  )
}
export const Caption2 = () => {
  const classes = useStyles()

  return (
    <Box component="section" className={classes.caption1}>
      <BackgroundVideo
        title={vidurl.title}
        _mp4_src={vidurl.videoSrcUrl}
        vidCustomStyle={classes.vidCustomStyle}
      />
      <Box className={classes.container}>
        <hr />
        <Typography component="blockquote" className={classes.quote}>
          Craving something else?
        </Typography>
        <hr />
        <Typography paragraph>
          "You can make a Special order for that meal you've been craving. Leave
          the preparation to us."
        </Typography>
      </Box>
    </Box>
  )
}
